import style from "./sign-in.module.css";
import SignInForm from "../../organisms/sign-in-form/signInForm";
import Navbar from "../landing-page/segments/navbar/navbar";

const SignIn = ({ auth }) => (
    <>
        <Navbar />
        <div className={style.signInWrapper}>
            <div className={style.mainWrapper}>
                <SignInForm auth={auth} nextPageUrl={"/sign-in"} />
            </div>
        </div>
    </>
);

export default SignIn;
